"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CollectionAssignCtrl = void 0;
const core_api_1 = require("@ikegps/core-api");
const i18n_1 = require("../../i18n");
const index_1 = require("../../services/index");
const page_state_1 = require("../../state/page.state");
const user_assign_modal_1 = require("../user.assign.modal/user.assign.modal");
exports.CollectionAssignCtrl = {
    canAssign() {
        return (index_1.Services.Token.has(core_api_1.IkeToken.FEATURE_COLLECTION_ASSIGN)
            || index_1.Services.Token.has(core_api_1.IkeToken.FEATURE_GROUP_IKE_ANALYZE));
    },
    showAssignModal() {
        const collections = page_state_1.CurrentState.Tag.collections;
        const confirmModal = new user_assign_modal_1.UserAssignModal({
            title: i18n_1.T.COLLECTION_ASSIGN_TITLE,
            confirm: i18n_1.T.COLLECTION_ASSIGN,
            success: {
                key: i18n_1.T.COLLECTION_ASSIGN_SUCCESS,
                attrs: {
                    count: collections.length
                }
            }
        }, collections);
        confirmModal.open();
    }
};
//# sourceMappingURL=collection.assign.ctrl.js.map